import React from 'react';

import {
  useEmailMessageTimelineLogItemsQuery,
  useWorkflowRunTimelineLogItemsQuery,
} from '@dashboard/generated/wp/platform';
import { Timeline, timelineItemClasses } from '@mui/lab';

import TimelineEvent from './TimelineEvent';

function useTimelineLogItemsQuery({ parentModelId, parentModelType }: Props) {
  const workflowRun = useWorkflowRunTimelineLogItemsQuery({
    pollInterval: 3000,
    variables: { id: parentModelId },
    skip: parentModelType !== 'WorkflowRun',
  });
  const emailMessage = useEmailMessageTimelineLogItemsQuery({
    pollInterval: 3000,
    variables: { id: parentModelId },
    skip: parentModelType !== 'EmailMessage',
  });
  switch (parentModelType) {
    case 'WorkflowRun':
      return workflowRun;
    case 'EmailMessage':
      return emailMessage;
  }
}

type Props = {
  parentModelId: string;
  parentModelType: 'WorkflowRun' | 'EmailMessage';
};
export default function TimelineBody({ parentModelId, parentModelType }: Props) {
  const { data } = useTimelineLogItemsQuery({ parentModelId, parentModelType });
  const nodes = data?.TimelineLogItems.nodes;
  if (!nodes) {
    return null;
  }
  return (
    <Timeline
      sx={{
        p: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {nodes.map((log, i) => (
        <TimelineEvent key={i} includeConnector={i === nodes.length - 1} event={log} />
      ))}
    </Timeline>
  );
}
